import { render, staticRenderFns } from "./expense-card-subtasks.vue?vue&type=template&id=0043b1ee&"
import script from "./expense-card-subtasks.vue?vue&type=script&lang=js&"
export * from "./expense-card-subtasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports